import { PetTypeEnum } from 'enums/PetType'
import styled from 'styled-components'
import dogAvatar from 'assets/img/dogAvatar.png'
import catAvatar from 'assets/img/catAvatar.png'

const defaultDiv = styled.div`
  padding: 0 24px;
  button {
    padding-left: 0px;
  }
`

export const Sign = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
`

export const Container = styled.div`
  height: calc(100vh - 54px);
  overflow: scroll;
`

export const SubscriptionDetails = styled.div`
  margin: 24px 24px 0 24px;
  padding: 16px;
  border: 1px solid var(--gray200);
  border-radius: 8px;

  .statusTag {
    span {
      margin-left: 0px;
      margin-top: 4px;
    }
  }
`

export const CancelationAlert = styled.div`
  margin: 24px;
`

export const QuickAccess = styled(defaultDiv)`
  display: flex;
  margin-top: 24px;
  margin-bottom: 48px;
  justify-content: space-between;
  align-items: flex-start;

  span {
    display: block;
  }

  button {
    display: block;
    max-width: 64px;
    padding: 0;
    text-align: center;

    &:hover:enabled {
      background-color: transparent;
    }
  }
`

export const QuickAccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: 0 auto 8px;
  background-color: var(--primary100);
  border-radius: 50%;
`

export const Footer = styled(defaultDiv)`
  margin-bottom: 24px;

  button {
    width: 100%;
    margin-bottom: 16px;
  }
`

export const BottomSheetContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  h3 {
    margin: 16px 0;
  }

  button {
    margin-top: 16px;
  }
`

export const BottomSheetDetails = styled.div`
  width: 100%;
  padding: 16px;
  border: 1px solid var(--gray200);
  border-radius: 8px;
  margin-bottom: 16px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background-color: var(--gray100);
    border-radius: 8px 8px 0 0;
    z-index: -1;
  }

  .statusTag {
    span {
      margin-left: 0px;
      margin-top: 4px;
    }
  }
`

export const BottomSheetLogo = styled.div<{ imagePath?: string }>`
  display: block;
  width: 64px;
  height: 16px;
  background-image: ${({ imagePath }) => (imagePath ? `url(${imagePath})` : 'none')};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const PetAvatar = styled.div<{ type?: string }>`
  display: block;
  width: 40px;
  height: 40px;
  background-image: ${({ type }) =>
    type === PetTypeEnum.DOG ? `url(${dogAvatar})` : `url(${catAvatar})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`

export const PrintPetPlanCardWrapper = styled.div`
  display: block;
  padding: 16px;
  width: 500px;
  position: absolute;
  left: -9999px;
  background-color: var(--neutral-theme);

  .contactInfo {
    color: var(--primary500);
    margin: 8px 0;
  }
`

export const Weekdays = styled.div`
  margin-top: 16px;
`
